var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRembardeReparee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fond",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 592.58 607.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rembarde r\xE9par\xE9e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rembarde_propre",
    "data-name": "rembarde propre"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1854,1735l.24-150.9,67.34-49.89v-14.1L1329,1967l2,4,4.47-4v161l584-440.42v-2.7Zm-513,381.15V1964.59l67.34-49.89L1408,2065Zm73.12-54.3V1910.29l67.74-50.07L1482,2010Zm73.5-54.51V1855.78l66.83-49.49L1555,1956Zm72.61-53.91V1801.87l67.34-49.88.48,150Zm73.5-54.5V1747.37l67.34-49.89,1,149.52Zm73.12-54.31V1693.06l68.16-50,1,150Zm73.92-54.47V1638.59l67.74-50.08L1849,1738Z",
    transform: "translate(-1329 -1520.11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRembardeReparee);
export default __webpack_public_path__ + "static/media/rembarde_reparee.1ba4442fdc9d3a932b78bef8605579ef.svg";
export { ForwardRef as ReactComponent };